import api from 'api'
import Constants from 'Constants'

const { SERVER_PORTAL_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getBusinessInfo: builder.query({
      query: businessName => ({
        method: 'GET',
        url: `${SERVER_PORTAL_URL}/api/v1/portal/business/${businessName}`,
      }),
      transformResponse: res => ({
        // Map portal-bootstrap shape onto the legacy keys the login containers
        // already read. Keeps the existing usage sites (`businessInfo.id`,
        // `businessInfo.businessTitle`) untouched.
        id: res.businessId,
        businessName: res.businessName,
        businessTitle: res.businessTitle,
        authTenantId: res.authTenantId,
        address: res.address,
        phoneNumber: res.phoneNumber,
        website: res.website,
        businessEmail: res.businessEmail,
      }),
    }),
  }),
})

export const { useLazyGetBusinessInfoQuery } = extendedApi
